import { useEffect } from "react"
import { connect } from "react-redux"
import { logoutUser } from "../../store/actions"
import { useMsal } from '@azure/msal-react'

const Logout = () => {
  const { instance } = useMsal();
  
  useEffect(() => {
    instance.logoutRedirect().catch((error) => console.log(error));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

export default connect(null, { logoutUser })(Logout)
